import messages from '../locales/nl_NL.json';

const lang = {
    messages: {
        ...messages,
    },
    locale: 'nl-NL',
};
export default lang;
